  // 앱/웹 공통: store에서 guestUserId 읽기
  // store에 없으면 query에서 읽기 (웹 다이렉트 접근 대응)
  // query.id 로 명시적으로 새 사주를 지정한 경우 query 가 우선
  const queryId = Number(route.query.id) || null;
  const newId = queryId || mobileSajuLnbStore.guestUserId || null;
  if (newId && (queryId || !mobileSajuLnbStore.guestUserId)) {
    mobileSajuLnbStore.setGuestUserId(newId);
  }<script setup>
// =============== 1. 초기 설정 ===============
// 외부 라이브러리
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';

// API
import { fetchBaseServiceAPI } from '@/api/baseServiceApi';
import { findTermsAPI } from '@/api/fortuneApi';

// Composables
import { useGesture } from '@/composables/calendar/useGesture';
import { useContentRate } from '@/composables/saju-insight/useContentRate';
import { useSajuData } from '@/composables/saju-insight/useSajuData';
import { useRnBridge } from '@/composables/useRnBridge';
import { useDialogManager } from '@/composables/useDialogManager';
import { isObjectEmpty } from '@/composables/functions';

// Store
import { useMobileSajuLnbStore } from '@/store/modules/mobileSajuLnb';
import { useAnalysisStore } from '@/store/modules/analysis';
import { useAnalysisDataStore } from '@/store/modules/analysisDataStore';

// Constants
import { DEV_MODE } from '@/config/dev-mode';
import {
  MOBILE_READING_CONTENTS,
  MOBILE_READING_SECTION_PAGE_MAP,
} from '@/pages/mobile/analysis-saju-reading/constants';

// Components
import BasicCover from '@/pages/mobile/analysis-saju-reading/_summary_01.vue';
import { addContentLogAPI } from '@/api/logServiceApi';
import BasicTOC from '@/pages/mobile/analysis-saju-reading/_summary_02.vue';
import PopDesc from '@/pages/mobile/analysis-saju-reading/_pop_desc.vue';
import summarySub01 from '@/pages/mobile/analysis-saju-reading/_summary_sub_01.vue';
import summarySub02 from '@/pages/mobile/analysis-saju-reading/_summary_sub_02.vue';
import summarySub03 from '@/pages/mobile/analysis-saju-reading/_summary_sub_03.vue';
import summarySub04 from '@/pages/mobile/analysis-saju-reading/_summary_sub_04.vue';
import summarySub05 from '@/pages/mobile/analysis-saju-reading/_summary_sub_05.vue';
import summarySub06 from '@/pages/mobile/analysis-saju-reading/_summary_sub_06.vue';
import summarySub07 from '@/pages/mobile/analysis-saju-reading/_summary_sub_07.vue';
import summarySub09 from '@/pages/mobile/analysis-saju-reading/_summary_sub_09.vue';
import summarySub10 from '@/pages/mobile/analysis-saju-reading/_summary_sub_10.vue';
import summarySub11 from '@/pages/mobile/analysis-saju-reading/_summary_sub_11.vue';
import summarySub12 from '@/pages/mobile/analysis-saju-reading/_summary_sub_12.vue';
import summarySub13 from '@/pages/mobile/analysis-saju-reading/_summary_sub_13.vue';
import summarySub14 from '@/pages/mobile/analysis-saju-reading/_summary_sub_14.vue';
import summarySub15 from '@/pages/mobile/analysis-saju-reading/_summary_sub_15.vue';
import summarySub16 from '@/pages/mobile/analysis-saju-reading/_summary_sub_16.vue';
import SurveyCard from '@/components/calendar/drawer/pages/cards/SurveyCard.vue';
import AnalysisLoadingOverlay from '@/components/saju-insight/common/AnalysisLoadingOverlay.vue';
import AlertComponent from '@/components/common/Alert.vue';

provide('fullWidthMode', true);

definePage({ meta: { layout: 'm-saju-insight' } });

const emit = defineEmits(['close']);

const route = useRoute();
const router = useRouter();
const store = useStore();

const analysisStore = useAnalysisStore();
const analysisDataStore = useAnalysisDataStore();
const mobileSajuLnbStore = useMobileSajuLnbStore();

// =============== 2. Alert / Dialog ===============
const { alertRef, dialogTitle, dialogText, dialogNextUrl, showAlert } = useDialogManager();

// =============== 3. 웹뷰 통신 ===============
const { debuggingHandler } = useRnBridge();

// =============== 4. PC 환경 ===============
const userId = ref(null);
userId.value = store.getters['user/id'];

// =============== 5. 사주 데이터 ===============
const {
  sajuData,
  birthData,
  transdata,
  birthJijanggan,
  daeunsData,
  birthEightTxt,
  sData,
  pSubData,
  baseCode,
} = storeToRefs(analysisDataStore);

const { initWithValidation, isLoadingSajuData } = useSajuData();

const closeSajuInsight = () => {
  router.push('/saju-service');
};

const initializeSajuData = () =>
  initWithValidation(guestUserId.value, { showAlert, onRestricted: closeSajuInsight });

/** 일간 구하기 */
const getDayData = (text) => {
  if (!text) return '';
  const data = text.split('');
  return data[2];
};

const sajuIlgan = computed(() => {
  const result = getDayData(birthEightTxt.value);
  return result;
});

// =============== 6. 데이터 조회 ===============
const isInitializingSajuDesc = ref(false);

/** 사주풀이 데이터 요청 */
const fetchSajuDescData = async () => {
  isInitializingSajuDesc.value = true;
  try {
    const params = {
      guestUserId: guestUserId.value,
      lang: 'KOR',
      birth: sajuData.value.solar ?? null,
      userName: sajuData.value.inputdata.name ?? store.userName,
      bln: sajuData.value.transdata.lucknum ?? null,
      gender: Number(sajuData.value.inputdata.gender) ?? null,
      unknownTime: sajuData.value.inputdata.unknown_time ?? null,
      analysisTypeId: 8,
    };

    if (isObjectEmpty(sData.value)) {
      const result = await fetchBaseServiceAPI(params);

      analysisDataStore.setSData(result.data);
      analysisDataStore.setSajuKeywords(result.data.용어해석);

      await fetchSajuWords(result.data.용어해석);
    }
  } catch (error) {
    DEV_MODE && console.error('fetchSajuDescData 실패,', error);
  } finally {
    isInitializingSajuDesc.value = false;
  }
};

const fetchSajuWords = async (words) => {
  if (words.length > 0) {
    try {
      if (isObjectEmpty(analysisDataStore.dictionaryData)) {
        const params = {
          keywordCategory: '용어사전',
          keyword: words,
        };
        const result = await findTermsAPI(params);

        if (result) analysisDataStore.setDictionaryData(result.data);
      }
    } catch (e) {
      debuggingHandler({
        action: 'error',
        message: `용어사전 데이터 요청 실패: ${JSON.stringify(e)}`,
      });
    }
  }
};

// =============== 7. 컨텐츠 평가 ===============
const guestUserId = ref(null);
const { ratingResult, ratingStatus, getRate, postRate } = useContentRate(
  'SAJU_INTERPRETATION',
  guestUserId,
);

// =============== 8. 페이지 상태 ===============
const currentPage = ref(0);
const bottomInset = ref(0);
const infoPage = ref(false);
const totalPages = ref(17);
const showSummary02 = ref(false);
const langMode = ref('CHNKOR');
const birthTitle = ref('시일월년');

// =============== 9. 팝업 / 모달 ===============
const showPopDesc = ref(false);

/** 팝업 닫기 */
const close = () => {
  router.back();
};

const resetPopup = () => {
  currentPage.value = 0;
  infoPage.value = false;
  showSummary02.value = false;
  showPopDesc.value = false;
};

const closePopDesc = () => {
  showPopDesc.value = false;
};

// =============== 10. 페이지 네비게이션 ===============
/** 페이지 이전/다음 이동 로그 — 버튼/스와이프 공통, 이동이 실제 발생한 경우만 발화 */
const logPageMove = () => {
  addContentLogAPI({
    contentType: 'as_summary_page_opt3',
    option3: String(currentPage.value),
  });
};

const clickPrevPage = () => {
  if (currentPage.value < 1) return;
  else currentPage.value -= 1;
  logPageMove();
  window.scrollTo(0, 0);
};

const clickNextPage = () => {
  if (currentPage.value >= totalPages.value) {
    goToCoverPage();
  } else {
    currentPage.value += 1;
    logPageMove();
  }
  window.scrollTo(0, 0);
};

const onSwipeLeft = () => {
  if (currentPage.value === 0 || currentPage.value >= totalPages.value) return;
  else currentPage.value += 1;
  logPageMove();
};

const onSwipeRight = () => {
  if (currentPage.value < 1) return;
  else currentPage.value -= 1;
  logPageMove();
};

/** 통합 제스처 핸들러 */
const { handleStart, handleMove, handleEnd } = useGesture({
  onSwipeLeft: onSwipeLeft,
  onSwipeRight: onSwipeRight,
  SWIPE_THRESHOLD: 150,
});

// 키보드 방향키로 페이지 이동 (개발용)
const onKeydown = (e) => {
  if (e.key === 'ArrowLeft') clickPrevPage();
  else if (e.key === 'ArrowRight') clickNextPage();
};

const goToCoverPage = () => {
  // 모바일은 별도 다시보기 버튼이 없어, 마지막 페이지에서 표지 복귀 시점을 다시보기로 집계
  addContentLogAPI('as_summary_btn_restart');
  currentPage.value = 0;
  showSummary02.value = false;
};

const clickUseSajuAnalysis = () => {
  // 조회 로그 — 사주풀이 시작 시점(무료 전용). PC와 동일 content_type 재사용(디바이스 구분은 백엔드 option2).
  addContentLogAPI('as_summary_btn_start_free');
  showSummary02.value = true;
  window.scrollTo(0, 0);
};

const handleNavigateToPage = (tocIdx) => {
  const mappedPage = MOBILE_READING_SECTION_PAGE_MAP[tocIdx];
  if (mappedPage !== undefined) {
    // 목차 클릭 로그 (사주풀이는 무료 전용이라 free). PC와 동일 content_type 재사용
    addContentLogAPI({ contentType: 'as_summary_toc_free_opt3', option3: String(tocIdx) });
    currentPage.value = mappedPage;
  } else {
    DEV_MODE && console.warn('매핑되지 않은 목차 인덱스입니다:', tocIdx);
  }
};

// =============== 11. 목차 UI ===============
const openFlag = ref('');
const openContentsList = () => {
  if (openFlag.value === '') openFlag.value = 'open';
  else openFlag.value = '';
};
const closeContentsList = () => (openFlag.value = '');
const updateIndexNo = (id, tocNo = null) => {
  // tocNo는 플로팅 목차 리스트 클릭 시에만 전달 — 프로그래밍 방식 이동은 발화하지 않음
  if (tocNo != null) {
    addContentLogAPI({ contentType: 'as_summary_toc_free_opt3', option3: String(tocNo) });
  }
  currentPage.value = id;
  closeContentsList();
};

// =============== 12. 공통 액션 ===============
// (해당 없음)

// =============== 13. Watch ===============
watch(
  () => mobileSajuLnbStore.guestUserId,
  (newId) => {
    if (newId) {
      guestUserId.value = newId;
    }
  },
);

watch(guestUserId, async (newId, oldId) => {
  if (newId && newId !== oldId) {
    const result = await initializeSajuData();
    if (result?.failed || result?.unknownTime || result?.futureSaju) return;
    // 사주 ID 변경 시 이전 사주의 사주풀이 데이터 초기화 (base-service 재호출 보장)
    analysisDataStore.setSData({});
    analysisDataStore.setSajuKeywords(null);
    analysisDataStore.setDictionaryData(null);
    await fetchSajuDescData();
    await getRate();
  }
});

// =============== 14. 라이프사이클 ===============
onMounted(async () => {
  // 웹 환경: 비로그인 접근 차단
  if (!userId.value && !sessionStorage.getItem('X-Token')) {
    showAlert({ title: '로그인 후 이용 가능합니다.', nextUrl: () => router.push('/auth/login') });
    return;
  }

  // 페이지 진입 로그 — 모바일은 LNB가 없어 진입 시점에 발화 (신규 type, DB 등록 후 작동)
  addContentLogAPI('as_summary_page_view');

  // 앱/웹 공통: store에서 guestUserId 읽기
  // store에 없으면 query에서 읽기 (웹 다이렉트 접근 대응)
  // query.id 로 명시적으로 새 사주를 지정한 경우 query 가 우선
  const queryId = Number(route.query.id) || null;
  const newId = queryId || mobileSajuLnbStore.guestUserId || null;
  if (newId && (queryId || !mobileSajuLnbStore.guestUserId)) {
    mobileSajuLnbStore.setGuestUserId(newId);
  }

  // 같은 ID여도 강제 재조회 (브라우저 캐시 대응)
  if (newId) {
    guestUserId.value = null;
    await nextTick();
    guestUserId.value = newId;
  }
});

onMounted(() => window.addEventListener('keydown', onKeydown));

onUnmounted(() => {
  window.removeEventListener('keydown', onKeydown);
  analysisStore.setSelectedContentIndex(null);
});
</script>

<template>
  <div
    class="pop-saju-reading-container mobile"
    @mousedown="handleStart"
    @mousemove="handleMove"
    @mouseup="handleEnd"
    @touchstart="handleStart"
    @touchmove="handleMove"
    @touchend="handleEnd"
  >
    <AnalysisMobileHeader title="사주풀이" :guestUserId="guestUserId" @close="close" />

    <div v-if="currentPage === 0" class="pop-ana-saju-reading-inner intro">
      <BasicCover
        v-if="!showSummary02"
        :guestUserName="analysisDataStore.paramData?.userName || mobileSajuLnbStore?.userName"
      />
      <AnalysisLoadingOverlay
        :loading="showSummary02 && isInitializingSajuDesc"
        :message="'상세 분석중입니다!'"
      />
      <BasicTOC
        v-if="showSummary02 && !isInitializingSajuDesc"
        :isReady="!isInitializingSajuDesc && !isObjectEmpty(sData)"
        @navigateToPage="handleNavigateToPage"
        @updateShowSummary02="
          (value) => {
            DEV_MODE && console.log('updateShowSummary02 received:', value);
            showSummary02 = value;
          }
        "
      />
      <div class="reading-cover__bottom-box">
        <button class="reading-btn__white" @click="clickUseSajuAnalysis" v-if="!showSummary02">
          사주풀이 시작하기 →
        </button>
      </div>
    </div>

    <div v-if="currentPage !== 0" class="pop-ana-saju-reading-inner st-page">
      <div v-if="currentPage === 1" class="pop-body mobile">
        <summarySub01 />
      </div>
      <div v-if="currentPage === 2" class="pop-body mobile">
        <summarySub02 />
      </div>
      <div v-if="currentPage === 3" class="pop-body mobile">
        <summarySub03
          :birthData="birthData"
          :transdata="transdata"
          :birthJijanggan="birthJijanggan"
          :langMode="langMode"
          :birthTitle="birthTitle"
          :curDaeun="analysisDataStore.curDaeun"
          :selectedData="selectedData"
          :isActive="isActive"
        />
      </div>
      <div v-if="currentPage === 4" class="pop-body mobile">
        <summarySub04 :birthData="birthData" :birthEightTxt="birthEightTxt" />
      </div>
      <div v-if="currentPage === 5" class="pop-body mobile">
        <summarySub05
          :birthData="birthData"
          :birthJijanggan="birthJijanggan"
          :langMode="langMode"
          :birthTitle="birthTitle"
          :transdata="transdata"
        />
      </div>
      <div v-if="currentPage === 6" class="pop-body mobile">
        <summarySub06
          :birthData="birthData"
          :birthJijanggan="birthJijanggan"
          :langMode="langMode"
          :birthTitle="birthTitle"
          :transdata="transdata"
        />
      </div>
      <div v-if="currentPage === 7" class="pop-body mobile">
        <summarySub07
          :langMode="langMode"
          :daeunsData="analysisDataStore.daeunsData"
          :daeunCurNum="analysisDataStore.daeunCurNum"
        />
      </div>
      <div v-if="currentPage === 8" class="pop-body mobile">
        <div class="sr__no-content-page">
          <div class="sr-next__top">
            <span>
              이제, 어렵게 느껴졌던 사주 키워드들이<br />
              조금은 더 편안하고 익숙하게 다가오셨다면?
            </span>
            <span><b>이제 사주팔자의 요약 해석을 만나보세요!</b></span>
          </div>
          <div class="sr-next__bottom">
            <button @click="handleNavigateToPage(2)" class="sr-next__btn">다음 페이지로 →</button>
          </div>
        </div>
      </div>
      <div v-if="currentPage === 9" class="pop-body mobile">
        <summarySub09
          :contentIndex="currentPage"
          :sData="sData"
          :sajuIlgan="sajuIlgan"
          :birthData="birthData"
          :transdata="transdata"
          :sajuData="sajuData"
          :birthJijanggan="birthJijanggan"
          :langMode="langMode"
          :birthTitle="birthTitle"
          :birthEightTxt="birthEightTxt"
        />
      </div>
      <div v-if="currentPage === 10" class="pop-body mobile">
        <summarySub10 :sData="sData" :sajuIlgan="sajuIlgan" :birthData="birthData" />
      </div>
      <div v-if="currentPage === 11" class="pop-body mobile">
        <summarySub11 :sData="sData" :sajuIlgan="sajuIlgan" />
      </div>
      <div v-if="currentPage === 12" class="pop-body mobile">
        <summarySub12
          :sData="sData"
          :sajuIlgan="sajuIlgan"
          :birthData="birthData"
          :transdata="transdata"
          :birthJijanggan="birthJijanggan"
          :curDaeun="curDaeun"
          :langMode="langMode"
          :birthTitle="birthTitle"
        />
      </div>
      <div v-if="currentPage === 13" class="pop-body mobile">
        <summarySub13
          :sData="sData"
          :sajuIlgan="sajuIlgan"
          :birthData="birthData"
          :transdata="transdata"
          :birthJijanggan="birthJijanggan"
          :curDaeun="curDaeun"
          :langMode="langMode"
          :birthTitle="birthTitle"
        />
      </div>
      <div v-if="currentPage === 14" class="pop-body mobile">
        <summarySub14
          :sData="sData"
          :sajuIlgan="sajuIlgan"
          :birthData="birthData"
          :transdata="transdata"
          :birthJijanggan="birthJijanggan"
          :curDaeun="curDaeun"
          :langMode="langMode"
          :birthTitle="birthTitle"
        />
      </div>
      <div v-if="currentPage === 15" class="pop-body mobile">
        <summarySub15 :sData="sData" />
      </div>
      <div v-if="currentPage === 16" class="pop-body mobile">
        <summarySub16 :sData="sData" />
      </div>
      <div v-if="currentPage === 17" class="pop-body mobile">
        <div class="sr__no-content-page">
          <SurveyCard
            style="width: 100%"
            :ratingResult="ratingResult"
            :ratingStatus="ratingStatus"
            @postRate="postRate"
          />
        </div>
      </div>

      <div class="contentsListBtnBox mobile">
        <div class="list-box" :class="openFlag">
          <ul class="list-li-box">
            <li
              class="li mobile"
              v-for="(item, tocIdx) in MOBILE_READING_CONTENTS.filter(
                (content) => content.title !== '',
              )"
              :key="item.id"
              @click="updateIndexNo(item.id, tocIdx + 1)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="pop-footer-page-box">
        <div class="pop-desc-box">
          <button class="btn-desc" @click="showPopDesc = true">📖 용어해석</button>
        </div>
        <div class="pop-pagination" v-if="!infoPage && currentPage !== 0">
          <IconList
            @click="openContentsList('open')"
            v-if="openFlag === ''"
            style="margin-top: 3px"
          />
          <IconClose01
            @click="openContentsList('')"
            v-if="openFlag === 'open'"
            style="margin-top: 3px"
          />
          <button class="pop-pagination__prev" @click="clickPrevPage">
            <i class="icon-chevron"></i>
          </button>
          <div class="pop-pagination__index" @click="openContentsList">
            {{ currentPage.toString().padStart(2, '0') }} /
            {{ totalPages.toString().padStart(2, '0') }}
          </div>
          <button class="pop-pagination__next" @click="clickNextPage">
            <i class="icon-chevron right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 용어해석 팝업 -->
  <PopDesc
    v-model="showPopDesc"
    :sajuKeywords="analysisDataStore.sajuKeywords"
    :dictionaryData="analysisDataStore.dictionaryData"
    @close="closePopDesc"
  />

  <AlertComponent ref="alertRef" :title="dialogTitle" :text="dialogText" :nextUrl="dialogNextUrl" />
</template>

<style lang="scss">
@import '@/assets/nangman_style/popup/saju-reading_mobile.scss';
@import '@/assets/nangman_style/mobile/saju-reading-common.scss';
@import '@/assets/nangman_style/_analysis_main_color.scss';
.detailed-overview {
  flex-direction: column;
  /* 네이버 인앱브라우저: TOC 렌더 시 콘텐츠가 짧으면 document 스크롤 불가 → 주소창이 페이지 위에 오버레이됨.
     강제로 viewport보다 약간 더 크게 만들어 항상 스크롤 가능 상태 유지 */
  min-height: calc(100vh + 1px);
}

/* 네이버 인앱브라우저 주소창 오버레이 방지: 문서 레벨 스크롤 전환 */
.pop-saju-reading-container.mobile {
  height: auto;
  min-height: 100vh;
  overflow: visible;

  > .header {
    position: sticky;
    top: 0;
    z-index: 20;
  }
}

.pop-ana-saju-reading-inner {
  height: auto;
  min-height: calc(100vh - 52px - var(--safe-area-top, 0px));
  overflow: visible;
  &.st-page {
    height: auto;
    min-height: calc(100vh - 52px - var(--safe-area-top, 0px));
    overflow: visible;
    padding-bottom: calc(52px + var(--safe-area-bottom, 0px));

    .contentsListBtnBox.mobile {
      position: fixed;
      bottom: calc(52px + var(--safe-area-bottom, 0px));
      right: 0;
    }
  }
  .reading-cover__bottom-box {
    position: fixed;
    bottom: var(--safe-area-bottom, 0px);
    left: 0;
    right: 0;
    width: 100%;
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    .reading-btn__white {
      display: flex;
      width: 100%;
      max-width: 500px;
      height: 48px;
      padding: 14px 20px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 6px;
      border: 1px solid var(--Gray-300, #ebebeb);
      background: var(--gray-100-white, #fff);
      box-shadow: 0px -10px 10px 0px rgba(0, 0, 0, 0.05);
      color: $analysis-saju;
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px; /* 133.333% */
    }
  }
  .pop-body {
    height: auto;
    padding: 0px;
    flex: 1;
    overflow: visible;
  }
}
.pop-footer-page-box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: var(--safe-area-bottom, 0px);
  background: #fff;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  .pop-desc-box {
    display: flex;
    width: 50%;
    height: 52px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    .btn-desc {
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: var(--gray-100-white, #fff);
      text-align: center;
      font-family: Pretendard;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px; /* 128.571% */
      background: var(--orange-300-main, #eb4c10);
    }
  }
  .pop-pagination {
    display: flex;
    height: 52px;
    padding: 14px 20px;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    background: var(--Gray-800, #333);
    color: var(--gray-100-white, #fff);
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    .pop-pagination__prev,
    .pop-pagination__next {
      width: 32px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .icon-chevron {
      width: 18px;
      height: 18px;
      mask: url('/src/assets/images_manse/chevron/chevron-left-16.svg') no-repeat center;
      -webkit-mask: url('/src/assets/images_manse/chevron/chevron-left-16.svg') no-repeat center;
      background-size: cover;
      background-color: var(--Gray-400, #c2c2c2);
      mask-size: 100% 100%;
      -webkit-mask-size: 100% 100%;
    }
    .icon-chevron.right {
      transform: rotate(180deg);
    }
  }
}
</style>
